import { useTranslation } from 'react-i18next';

/**
 * Label of a link to /app: "Sign in", or "Dashboard" once this browser has signed in. Both are in
 * the markup and CSS shows one, so prerendered pages are right from the first paint.
 */
export function SignInLabel() {
  const { t } = useTranslation();
  return (
    <>
      <span className="if-signed-out">{t('nav.signIn')}</span>
      <span className="if-signed-in">{t('nav.dashboard')}</span>
    </>
  );
}
